import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050e1d] text-[#f4f0e6] overflow-hidden grain"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-14 lg:py-16 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          <div className="lg:col-span-4">
            <p className="overline-tag opacity-60">Medical + Equal Care</p>
            <p className="mt-4 max-w-[320px] text-sm leading-relaxed text-[#f4f0e6]/60">
              Licensed clinical care within the customer relationship.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <p className="overline-tag opacity-40 mb-4">Company</p>
              <ul className="space-y-2 text-sm">
                <li><Link to="/about" className="hover:text-[#f26522] transition-colors">About</Link></li>
                <li><Link to="/how-it-works" className="hover:text-[#f26522] transition-colors">How it works</Link></li>
                <li><Link to="/markets" className="hover:text-[#f26522] transition-colors">Focus markets</Link></li>
                <li><Link to="/contact" className="hover:text-[#f26522] transition-colors">Contact</Link></li>
              </ul>
            </div>

            <div>
              <p className="overline-tag opacity-40 mb-4">Sectors</p>
              <ul className="space-y-2 text-sm">
                <li><Link to="/for-insurance" className="hover:text-[#f26522] transition-colors">Insurance</Link></li>
                <li><Link to="/for-banking" className="hover:text-[#f26522] transition-colors">Banking</Link></li>
                <li><Link to="/for-coops-and-associations" className="hover:text-[#f26522] transition-colors">Co-ops &amp; Associations</Link></li>
              </ul>
            </div>

            <div>
              <p className="overline-tag opacity-40 mb-4">Business inquiries</p>
              <ul className="space-y-3 text-sm">
                <li>
                  <a
                    href="mailto:mj@medicual.com"
                    data-testid="footer-email"
                    className="hover:text-[#f26522] transition-colors"
                  >
                    mj@medicual.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/255744919118"
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-whatsapp"
                    className="hover:text-[#f26522] transition-colors"
                  >
                    WhatsApp<br />+255 744 919118
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="hairline bg-[#f4f0e6] mt-12 lg:mt-14" />
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-6 overline-tag opacity-55">
          <div>© Medicual AB · CE-marked · Since 2013</div>
          <div>Healthcare, Anywhere.</div>
        </div>
      </div>
    </footer>
  );
}
